var map = {
	"./basket/calendar.svg": 120,
	"./basket/clock.svg": 121,
	"./basket/musement_logo.svg": 122,
	"./basket/people.svg": 123,
	"./basket/star.svg": 124,
	"./feature_icons/ADDVA_ENTRAN.svg": 74,
	"./feature_icons/ADDVA_EXCLUS.svg": 75,
	"./feature_icons/ADDVA_GUIDE.svg": 76,
	"./feature_icons/ADDVA_KIDS.svg": 77,
	"./feature_icons/ADDVA_LOCAL.svg": 78,
	"./feature_icons/ADDVA_MEAL.svg": 79,
	"./feature_icons/ADDVA_PRITOU.svg": 80,
	"./feature_icons/ADDVA_SMALL.svg": 81,
	"./feature_icons/ADDVA_SUBJEC.svg": 82,
	"./feature_icons/ADDVA_TOURAU.svg": 83,
	"./feature_icons/ADDVA_VOUCH.svg": 84,
	"./feature_icons/default_icon.svg": 85,
	"./feature_icons/fast.svg": 86,
	"./feature_icons/free.svg": 87,
	"./feature_icons/istant.svg": 88,
	"./feature_icons/official.svg": 89,
	"./feature_icons/skip.svg": 90,
	"./included.svg": 125,
	"./meeting_point.svg": 91,
	"./not_included.svg": 126
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;